import { XIcon, SquareDownArrow, SquareUpArrow } from 'assests/GmsIcons';
import React, { Dispatch, SetStateAction, useState } from 'react';

type TSelectTarget = {
    options: TOption[],
    setOptions?: Dispatch<SetStateAction<TOption[]>>
    header: string;
    remove: boolean;
}

const ChipsDropDown = ({ options, setOptions, header, remove }: TSelectTarget) => {

    const [expand, setExpand] = useState<boolean>(false)

    const handleRemoveProduct = (productId: string) => {
        setOptions && setOptions(prev => {
            const newState = [...prev]
            return newState.filter(x => x.id !== productId)
        }) 
    }

    return (
        <div className={`tw-w-full tw-h-auto tw-px-2.5 tw-bg-surface tw-rounded tw-border tw-border-edge tw-justify-center tw-items-center tw-gap-2.5 `}>
            <div className="tw-border-edge tw-h-9 tw-justify-center tw-text-sm tw-items-center tw-gap-2.5 tw-flex"  >
                <div className="tw-grow tw-shrink tw-basis-0 tw-text-ink">{header}</div>
                <div className="tw-text-ink">{options.length}</div>
                <div role="button" data-testid="components-chipsdropdown-div-1" onClick={() => setExpand(prev => !prev)}>
                    {
                        expand ?
                            <SquareUpArrow /> :
                            <SquareDownArrow />
                    }
                </div>

            </div >
            {
                expand ?
                    <>
                        {<div className="tw-w-full tw-h-[0px] tw-mb-2 tw-border tw-border-edge"></div>}
                        <div className='tw-max-h-[150px]  tw-w-auto tw-overflow-y-auto tw-mb-2'>
                            {options?.length === 0 ? <p className='tw-text-ink-tertiary'>No Data </p> : null}
                            {options?.map((option, index) =>
                                <div key={index} className="tw-px-[8px] tw-bg-surface-sunken tw-m-1 tw-rounded-sm tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
                                    <div className="tw-text-ink  tw-text-xs tw-w-auto">{option?.name}</div>
                                    {remove ? <div aria-label="Close" role="button" data-testid="components-chipsdropdown-div-2" className="tw-w-auto tw-h-6 tw-relative tw-cursor-pointer" onClick={() => {
                                        handleRemoveProduct(option?.id as string)
                                    }}><XIcon /></div> : null}
                                </div>
                            )}
                        </div>
                    </>
                    : null
            }
        </div >
    )
}

export default ChipsDropDown;